import React from 'react';
import SolutionRequestEstimatePlaceContainer from 'containers/SolutionRequestEstimatePlaceContainer/SolutionRequestEstimatePlaceContainer';

export default function SolutionRequestEstimatePlacePage() {
    return (
        <SolutionRequestEstimatePlaceContainer />
    )
}
